/**
 * fileSubmissionImportColumns.js
 *
 * Column definitions for the CSV import preview DataTable shown in ImportFileSessionsMd.
 * Mirrors the export CSV column layout so trainers can verify their edits before
 * committing the import.
 *
 * Writable fields (Score, Result, Remarks, ShowRemarks) are the only ones updated
 * by the import API; all other columns are context-only and displayed read-only.
 *
 * Used with react-data-table-component's `columns` prop.
 */

/**
 * Column configuration for the file submission import preview table.
 * Each column maps to a header field from the export CSV to allow
 * round-trip import of previously exported files.
 */
const fileSubmissionImportColumns = [
  {
    name: 'Row',
    selector: (row) => row.rowNumber,
    width: '65px',
    sortable: true,
  },
  {
    name: 'FileSubmissionSessionId',
    selector: (row) => row.FileSubmissionSessionId,
    width: '185px',
    sortable: true,
  },
  {
    name: 'SubQuestId',
    selector: (row) => row.SubQuestId,
    width: '105px',
    sortable: true,
  },
  {
    name: 'SubQuestName',
    selector: (row) => row.SubQuestName,
    sortable: true,
    wrap: true,
  },
  {
    name: 'UserId',
    selector: (row) => row.UserId,
    width: '80px',
    sortable: true,
  },
  {
    name: 'UserName',
    selector: (row) => row.UserName,
    sortable: true,
    wrap: true,
  },
  {
    name: 'Code',
    selector: (row) => row.Code,
    width: '90px',
    sortable: true,
  },
  {
    name: 'ScoreType',
    selector: (row) => row.ScoreType,
    width: '110px',
    sortable: true,
  },
  {
    name: 'TotalScore',
    selector: (row) => row.TotalScore,
    width: '100px',
    sortable: true,
  },
  {
    name: 'PassingScore',
    selector: (row) => row.PassingScore,
    width: '115px',
    sortable: true,
  },
  {
    name: 'FilePaths',
    selector: (row) => row.FilePaths,
    sortable: true,
    wrap: true,
  },
  // --- Writable fields below (updated by the import API) ---
  {
    name: 'Score',
    selector: (row) => row.Score,
    width: '75px',
    sortable: true,
  },
  {
    name: 'Result',
    selector: (row) => row.Result,
    width: '90px',
    sortable: true,
  },
  {
    name: 'Remarks',
    selector: (row) => row.Remarks,
    sortable: true,
    wrap: true,
  },
  {
    name: 'ShowRemarks',
    selector: (row) => row.ShowRemarks,
    width: '125px',
    sortable: true,
  },
];

export default fileSubmissionImportColumns;
